import { useEffect } from 'react';

const GAP_CLASSES = ['editor-element', 'layout-wrapper', 'layout-container', 'layout-cell'];

function isGap(editorElement, target) {

  if (target === editorElement) {
    return true;
  }

  if (editorElement.contains(target) === false) {
    return false;
  }

  for (let index = 0; index < GAP_CLASSES.length; index++) {
    if (target.classList.contains(GAP_CLASSES[index]) === true && target.closest('.editor-element') === editorElement) {
      return true;
    }
  }

  return false;

}

export function focusLayoutHandle(nodeMain) {

  const handle = nodeMain.querySelector(':scope > .node-handles-container button');

  if (handle !== null) {
    handle.focus();
  }

}

function handleMouseDown(editorElement, event) {

  if (event.button !== 0 || isGap(editorElement, event.target) === false) {
    return;
  }

  event.preventDefault();
  focusLayoutHandle(editorElement.closest('.editor-node-main'));

}

// Clicking a layout's padding, a gap or empty cell space selects the layout instead of placing
// the caret there.
export function useGapFocus(containerReference) {

  useEffect(function onLoad() {

    const editorElement = containerReference.current.closest('.editor-element');
    const listener = handleMouseDown.bind(null, editorElement);

    editorElement.addEventListener('mousedown', listener);

    return function onUnload() {
      editorElement.removeEventListener('mousedown', listener);
    };

  }, [containerReference]);

}
